module.exports = __webpack_public_path__ + "static/media/new2-mob.9c387384.png";